export default "__VITE_ASSET__BEHHN9Q1__"